<template>
  <!-- 数据块，将有关联性的数据放在一起 -->
  <div class="list-card" :class="`type-${type}`">
    <slot name="icon"/>
    <div class="card-info">
      <div v-if="showTitle" class="card-title">
        <div class="name">{{label}}</div>
        <div class="desc"><slot name="desc">{{desc}}</slot></div>
      </div><div class="card-content">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";

export default {
  props: {
    label: {default: ''},
    desc: {default: ''},
    showTitle: {default: true}, // 显示标题
    type: { // 样式，有list和form两种,list用于列表数据显示，form用于form表单提交
      type: String, // 指定prop的类型为String
      validator: function(value) {
        // 验证value是否为预定义的枚举值之一
        return ['list', 'form'].indexOf(value) !== -1;
      },
      default: 'list'
    },
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "DC",
  components: {
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.list-card{
  display: flex;
  justify-content: space-between;
  background: #FFF;
  margin-top: 10px;
  border-radius: 6px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  box-sizing: border-box;
  padding: 10px;
  &:first-child{
    margin-top: 0;
  }
  .card-info{
    flex: 1;
    width: 100px;
    overflow: hidden;
    .card-title{

      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      .name{
        font-size: var(--yq-font-size-small-mobile);
        white-space: nowrap;
        overflow: hidden;
        //font-weight: 500;
      }
      .desc{
        color: var(--yq-font-color-desc);
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
  .card-content{
    :deep(.data-column:first-child) {
      margin-top: 0;
    }
  }
}
.type-list{
  .card-info{
    //border-bottom: 1px solid var(--yq-border-color);
  }
}
.type-form{
  .card-info{
    .card-title{
      .name{
        font-size: var(--yq-font-size-small-mobile);
        color: var(--yq-font-color-desc);
      }
    }

  }

}
</style>